/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */
import React from 'react';
import appStoreBadge from '../assets/badges/app-store-badge-black.svg';

/**
 * The app's App Store listing — the iOS counterpart of PLAY_STORE_URL in
 * PlayStoreIcon. Import it from here rather than writing the URL out again.
 */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/athlohive/id6824261585';

/**
 * AppStoreBadge Component
 *
 * Apple's official "Download on the App Store" badge, linked to our listing.
 * Apple's App Store Marketing Guidelines allow only the supplied artwork: no
 * home-made button, no Apple logo on its own, no recolouring or cropping. The
 * SVG in assets/badges is the file from Apple's marketing toolbox, unedited;
 * it is only scaled. Keep it at least 40px tall, with clear space of a quarter
 * of its height around it, and list it first when shown with other stores.
 *
 * Props:
 * - height: (number) rendered height in pixels, default 42 (matches .fd-btn).
 * - className: (string) extra class for the link.
 */
const AppStoreBadge = ({ height = 42, className = '' }) => (
  <a
    className={`fd-appstore-badge ${className}`.trim()}
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
  >
    <img src={appStoreBadge} alt="Download on the App Store" height={height} style={{ height }} />
  </a>
);

export default AppStoreBadge;
